<template>
  <button
    type="button"
    :disabled="disabled"
    class="button"
    :class="{
      big: sizeBig,
      green: colorGreen
    }"
    @click.prevent.stop="click"
  >
    <span
      v-if="!spinner"
      class="label"
    >
      {{ label }}
      <font-awesome-icon :icon="icon"/>
    </span>
    <span
      v-if="spinner"
      class="spinner"
    >
      <font-awesome-icon icon="rotate"/>
    </span>
  </button>
</template>

<style scoped>
  .button {
    box-sizing: border-box;
    padding: 5px;
    font-size: 1.2rem;
    font-weight: 600;
    text-transform: uppercase;
    text-align: center;
    color: var(--primary-text-color-white);
    background-color: var(--primary-color);
    border: none;
    border-radius: 3px;
    opacity: 1;
    transition-property: background-color, opacity;
    transition-duration: 0.2s;
    cursor: pointer;
    z-index: 20;
  }

  .button.big {
    width: 200px;
    height: 50px;
    font-size: 1.3rem;
  }

  .button.green {
    background-color: #35c589;
  }

  .button:hover,
  .button:focus,
  .button:active,
  .button:disabled {
    background-color: var(--secondary-color);
  }

  .button.green:hover,
  .button.green:focus,
  .button.green:active,
  .button.green:disabled {
    background-color: #67d5a7;
  }

  .button:disabled {
    cursor: default;
  }

  .label > svg {
    margin-left: 5px;
  }

  @keyframes rotateSpinner {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  .spinner {
    display: inline-block;
    animation: rotateSpinner 1.5s linear infinite;
    transform: rotate(0deg);
  }
</style>

<script>
  export default {
    props: [
      'click',
      'label',
      'icon',
      'disabled',
      'spinner',
      'colorGreen',
      'sizeBig'
    ]
  }
</script>
